import { render, staticRenderFns } from "./VariableSelector.vue?vue&type=template&id=2a1df523&scoped=true"
import script from "./VariableSelector.vue?vue&type=script&lang=ts"
export * from "./VariableSelector.vue?vue&type=script&lang=ts"
import style0 from "./VariableSelector.vue?vue&type=style&index=0&id=2a1df523&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1df523",
  null
  
)

export default component.exports